import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

const tagSlice = (state: RootState) => state.tags;

const allTagsQuery = createSelector(tagSlice, ({ tags }) => tags);

export { allTagsQuery };
